import React, {useContext} from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Link} from "react-router-dom";
import ThemeContext from '../../Context/ThemeContext'
import ThemeNavbar from './ThemeNavbar';
import ThemeLogout from './ThemeLogout';


function ThemeTopBar() {
  const {isMobile} = useContext(ThemeContext);
  return (
    <div className="topbar position-relative mb-4 d-flex shadow bg-white">
      {isMobile && 
      <>
        <div className="mobile-menu-container ms-1 me-auto mt-auto mb-auto">
          <ThemeNavbar />
        </div>
        <div className="mobile-logo m-auto">
          <div className="menu-logo-image">
            <Link to="">
              <img alt="manpower-menu-logo" src={process.env.PUBLIC_URL + '/assets/images/manpower-login-logo.png'} />
            </Link>
          </div>
        </div>
      </>        
      }

      <div className="account-topbar ms-auto mt-auto mb-auto">
        <Dropdown className="account-button">
          <Dropdown.Toggle variant="transparent" id="dropdown-account-button">
            <FontAwesomeIcon icon="fa-circle-user" />            
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <ThemeLogout />
          </Dropdown.Menu>
        </Dropdown>
      </div>      
    </div>
  )
}


export default ThemeTopBar